export default __webpack_public_path__ + "static/media/calendarGreen.7a673766.svg";